import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import MenuCheckBox from '../MenuCheckBox';
import MenusItem from '../MenusItem';
import MenuCurrencyDropdown from 'components/dashboard/menu-links-content/MenuCurrencyDropdown';
import CommonLinkDeleteButton from 'components/common/link-elements/CommonLinkDeleteButton';
import MenuAdditionalProps from 'components/dashboard/menu-links-content/MenuAdditionalProps';
import { createMenusItem, patchMenuLink } from 'redux/menu-links/actions';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import CommonMessage from 'components/common/CommonMessage';
import { connect } from 'react-redux';
import './MenuLinkItemExpandedContent.css';

function MenuLinkItemExpandedContent(props) {
  const { me, item, patchMenuLink, deleteMenuLink, createMenusItem } = props;
  const menuItems = item.menu_items;
  const locked = me && me.subscription && !me.subscription.ff_menu;
  const { t } = useTranslation();
  const placeholderContent = (<div>{t("This options is available on the PRO plan.")}</div>);
  const isPro = me && me.subscription && me.subscription.ff_menu;
  const itemsLength = item.menu_items.length < 5;
  const [limitItems, setLimitItems] = useState(false);

  useEffect(() => {
    if (!isPro && itemsLength ) {
      setLimitItems(false);
    } else if (isPro){
      setLimitItems(false);
    }else {
      setLimitItems(true);
    }
  })
  
  return (
    <div className="menu-link-item-expanded-content__component">
      <div className="main-title">{t("Items & Prices")}</div>
      <hr />

      <div className="menu-item-info">
        <div className="menus-items">
          {menuItems.map((menusItem) => (
            <MenusItem
              key={`menus-item-key-${menusItem.id}`}
              menusItem={menusItem}
            />
          ))}
        </div>

        {/*  Add menus item button   */}
        { !limitItems &&
        <div className="add-additional-item" 
          onClick={ () => {createMenusItem({menu: item.id})} }
          role="button"
          tabIndex={-1}
        >
          <div className="add-icon"></div>
          <div className="text">{t("Add additional item")}</div>
        </div>}

        {item.menu_items && item.menu_items.length === 5 && locked &&
          <CommonMessage warning>{t("You can create more then 5 items on the PRO plan")}
          </CommonMessage>
        }

        <div className="currency">
          <div className="text">{t("Currency")}</div>
          <div className="currency-list">
            <MenuCurrencyDropdown menuItem={item} />
          </div>
        </div>
        <ProFeaturePlaceholder
          noKeyIcon
          locked={locked}
          placeholderContent={placeholderContent}
        >
          <div className="menu-is-expanded">
            <MenuCheckBox
              key={`menu-is-expanded-key-${item.id}`}
              linkId={item.id}
              label={t("Menu is expanded")}
              proLabel
              initialValue={item.is_expanded}
              disabled={locked}
              parameter="is_expanded"
              patchFunction={patchMenuLink}
            />
          </div>
          <div className="add-link">
            <MenuCheckBox
              key={`menu-add-link-checkbox-key-${item.id}`}
              linkId={item.id}
              label={t("Add link")}
              proLabel
              initialValue={item.is_link_enable}
              disabled={locked}
              parameter="is_link_enable"
              patchFunction={patchMenuLink}
            />
          </div>
        </ProFeaturePlaceholder>
        {item && item.is_link_enable && 
        <div className="menu-additional-props">
          <MenuAdditionalProps
            linkItem={item}
          />
        </div>}
        <div className="delete">
          <CommonLinkDeleteButton
            key={`menu-link-delete-icon-key-${item.id}`}
            linkItem={item}
            deleteFunction={deleteMenuLink}
          />
        </div>
        
      </div>
    </div>
  );
}

MenuLinkItemExpandedContent.propTypes = {
  me: PropTypes.object, 
  item: PropTypes.object.isRequired, 
  patchMenuLink: PropTypes.func.isRequired, 
  deleteMenuLink: PropTypes.func.isRequired, 
  createMenusItem: PropTypes.func.isRequired, 
}

MenuLinkItemExpandedContent.defaultProps = {
  me: null,
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    lastpatchedId: state.commonReducer.lastPatchedId,
  }
)

export default connect(mapStateToProps, 
  {
    createMenusItem,
    patchMenuLink,
}) (MenuLinkItemExpandedContent);